module.exports = __webpack_public_path__ + "e999181fcc84c8177bb6e8d731bfea2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/apple_2023_chart.png
// module id = 1634
// module chunks = 0